// removed by extract-text-webpack-plugin
module.exports = {"menu-link":"_3AeFY3WE","menuLink":"_3AeFY3WE","children":"_1W9-AzOl","active":"ab9TB4q_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuBar/MenuLink/MenuLink.pcss
// module id = 1017
// module chunks = 0